import AuthGuard from './authGuard'
import NotFoundGuard from './notFoundGuard'
import LogGuard from './logGuard'
import SideBarGuard from './sideBarGuard'

export default [
    NotFoundGuard,
    AuthGuard,
    LogGuard,
    SideBarGuard
]
  